













/* Created- 10 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonListV2.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardMid.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import { eParticaAction, ParticaEvent, getActionName } from "../../../Models/ParticaEvent";
import ParticaWebsiteBase from "../../Base/ParticaWebsiteBase.vue";


@Component(
	{
		name: "WebsiteConfiguration",
		components: {
			ParticaError,
			ParticaRowContainer,
			ParticaColumnContainer,
			ButtonList,
			ParticaCard,
			ParticaView
		}
	})
export default class WebsiteConfiguration extends ParticaWebsiteBase {
	@Prop() private id: number;


	private buttons: ButtonConfig[] = [
		{
			label: "Configure",
			action: eParticaAction.WEBSITE_SEARCH_CONFIG,
			type: ButtonType.Normal,
			title: "Viewer Search",
			help: "Configure how search works and displays in the viewer."
		} as ButtonConfig,
		{
			label: "Configure",
			action: eParticaAction.WEBSITE_TOC_CONFIG,
			type: ButtonType.Normal,
			title: "Table Of Contents",
			help: "Configure how table of contents displays in the viewer."

		} as ButtonConfig,
		{
			label: "Configure",
			action: eParticaAction.WEBSITE_TEMPLATE_CONFIG,
			type: ButtonType.Normal,
			title: "Viewer Templates",
			help: "Configure the templates the viewer displays for this viewer."

		} as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.WEBSITE_SEARCH_CONFIG: {
					this.navigate("searchconfiguration", { id: this.id.toString() });
					break;
				}
				case eParticaAction.WEBSITE_TEMPLATE_CONFIG: {
					this.navigate("templateconfiguration", { id: this.id.toString() });
					break;
				}
				case eParticaAction.WEBSITE_TOC_CONFIG: {
					this.navigate("tocconfiguration", { id: this.id.toString() });
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		this.breadcrumbs = [];
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Viewer Configuration";
		await this.init();
		await this.getWebsiteNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
